import React, { useEffect, useState } from "react";
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import { db } from "../firebase";
import Sidebar from "../components/Sidebar";
import { Modal, Button } from "react-bootstrap";

export default function LocationManager() {
  const [vehicules, setVehicules] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [vueTable, setVueTable] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchVehicules = async () => {
      const snap = await getDocs(collection(db, "vehicules_auto"));
      const list = snap.docs.map((item) => ({
        id: item.id,
        ...item.data(),
      }));
      setVehicules(list);
    };

    fetchVehicules();
  }, []);

  const toggleLocation = async (vehicule) => {
    const isActive = vehicule.location?.estDisponible || false;
    const vehiculeRef = doc(db, "vehicules_auto", vehicule.id);

    await updateDoc(vehiculeRef, {
      "location.estDisponible": !isActive,
    });

    setVehicules((prev) =>
      prev.map((v) =>
        v.id === vehicule.id
          ? {
              ...v,
              location: {
                ...(v.location || {}),
                estDisponible: !isActive,
              },
            }
          : v
      )
    );
  };

  const toggleVente = async (vehicule) => {
    const isEnVente = vehicule.enVente || false;
    const vehiculeRef = doc(db, "vehicules_auto", vehicule.id);

    await updateDoc(vehiculeRef, {
      enVente: !isEnVente,
    });

    setVehicules((prev) =>
      prev.map((v) =>
        v.id === vehicule.id
          ? {
              ...v,
              enVente: !isEnVente,
            }
          : v
      )
    );
  };

  const openImageModal = (images) => {
    setSelectedImages(images || []);
    setShowModal(true);
  };

  const filteredVehicles = vehicules.filter((vehicule) =>
    `${vehicule.marque || ""} ${vehicule.modele || ""} ${vehicule.annee || ""}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  return (
    <div className="d-flex flex-column flex-md-row">
      <Sidebar />

      <main className="flex-grow-1 p-4" style={{ marginLeft: "250px" }}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-3">
            <h2 className="mb-0">Gestion des Véhicules</h2>

            <div className="mb-0" style={{ minWidth: "280px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Rechercher une marque, un modèle, une année..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            <button
              className="btn btn-outline-dark btn-sm"
              onClick={() => setVueTable(!vueTable)}
            >
              {vueTable ? "🗂 Vue cartes" : "📋 Vue tableau"}
            </button>
          </div>

          {vueTable ? (
            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead className="table-dark">
                  <tr>
                    <th>Image</th>
                    <th>Nom</th>
                    <th>Location</th>
                    <th>Vente</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredVehicles.map((vehicule) => (
                    <tr key={vehicule.id}>
                      <td>
                        {vehicule.imageUrls?.[0] && (
                          <img
                            src={vehicule.imageUrls[0]}
                            alt={`${vehicule.marque || "Véhicule"} ${vehicule.modele || ""}`}
                            style={{
                              width: 80,
                              height: 50,
                              objectFit: "cover",
                              cursor: "pointer",
                            }}
                            onClick={() => openImageModal(vehicule.imageUrls)}
                          />
                        )}
                      </td>

                      <td>
                        <strong>
                          {`${vehicule.marque || ""} ${vehicule.modele || ""} ${vehicule.annee || ""}`}
                        </strong>
                      </td>

                      <td>
                        {vehicule.location?.estDisponible ? (
                          <span className="badge bg-success">Disponible</span>
                        ) : (
                          <span className="badge bg-secondary">Indisponible</span>
                        )}
                      </td>

                      <td>
                        {vehicule.enVente ? (
                          <span className="badge bg-success">Activée</span>
                        ) : (
                          <span className="badge bg-secondary">Désactivée</span>
                        )}
                      </td>

                      <td className="d-flex gap-2 flex-wrap">
                        <button
                          className={`btn btn-sm ${
                            vehicule.location?.estDisponible
                              ? "btn-outline-danger"
                              : "btn-outline-success"
                          }`}
                          onClick={() => toggleLocation(vehicule)}
                        >
                          {vehicule.location?.estDisponible
                            ? "Désactiver Location"
                            : "Activer Location"}
                        </button>

                        <button
                          className={`btn btn-sm ${
                            vehicule.enVente
                              ? "btn-outline-warning"
                              : "btn-outline-primary"
                          }`}
                          onClick={() => toggleVente(vehicule)}
                        >
                          {vehicule.enVente
                            ? "Retirer Vente"
                            : "Activer Vente"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="row">
              {filteredVehicles.map((vehicule) => (
                <div className="col-md-6 col-lg-4 mb-4" key={vehicule.id}>
                  <div className="card h-100 shadow-sm">
                    {vehicule.imageUrls?.[0] && (
                      <img
                        src={vehicule.imageUrls[0]}
                        alt={`${vehicule.marque || "Véhicule"} ${vehicule.modele || ""}`}
                        className="card-img-top"
                        style={{
                          height: 180,
                          objectFit: "cover",
                          cursor: "pointer",
                        }}
                        onClick={() => openImageModal(vehicule.imageUrls)}
                      />
                    )}

                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title">
                        {vehicule.marque} {vehicule.modele}
                      </h5>

                      <p className="card-text">
                        Année : {vehicule.annee} <br />
                        En Location :{" "}
                        <strong
                          className={
                            vehicule.location?.estDisponible
                              ? "text-success"
                              : "text-muted"
                          }
                        >
                          {vehicule.location?.estDisponible ? "Oui" : "Non"}
                        </strong>
                        <br />
                        En Vente :{" "}
                        <strong
                          className={
                            vehicule.enVente ? "text-success" : "text-muted"
                          }
                        >
                          {vehicule.enVente ? "Oui" : "Non"}
                        </strong>
                      </p>

                      <div className="mt-auto d-flex gap-2">
                        <button
                          className={`btn btn-sm w-100 ${
                            vehicule.location?.estDisponible
                              ? "btn-outline-danger"
                              : "btn-outline-success"
                          }`}
                          onClick={() => toggleLocation(vehicule)}
                        >
                          {vehicule.location?.estDisponible
                            ? "Désactiver Location"
                            : "Activer Location"}
                        </button>

                        <button
                          className={`btn btn-sm w-100 ${
                            vehicule.enVente
                              ? "btn-outline-warning"
                              : "btn-outline-primary"
                          }`}
                          onClick={() => toggleVente(vehicule)}
                        >
                          {vehicule.enVente
                            ? "Retirer Vente"
                            : "Activer Vente"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Images du véhicule</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectedImages.length > 0 ? (
            <div id="carouselVehicule" className="carousel slide" data-bs-ride="carousel">
              <div className="carousel-inner">
                {selectedImages.map((url, idx) => (
                  <div
                    key={idx}
                    className={`carousel-item ${idx === 0 ? "active" : ""}`}
                  >
                    <img
                      src={url}
                      className="d-block w-100"
                      alt={`Vue ${idx + 1} du véhicule`}
                    />
                  </div>
                ))}
              </div>

              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselVehicule"
                data-bs-slide="prev"
              >
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Précédent</span>
              </button>

              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselVehicule"
                data-bs-slide="next"
              >
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Suivant</span>
              </button>
            </div>
          ) : (
            <p>Aucune image à afficher.</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}